<div class="navigation-wrapper aspect-[720/554] w-[45rem] max-w-full">
  <div #sliderRef [ngClass]="slider ? 'loaded' : 'not-loaded'" class="keen-slider keen-slider--vertical">
    @for (image of images(); track image.url) {
      <div class="keen-slider__slide">
        <img [alt]="image.caption" [ngSrc]="image.url" fill="true">
      </div>
    }
  </div>
  @if (slider) {
    <div (click)="slider.prev()" class="arrow arrow--left">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"
        />
      </svg>
    </div>
    <div (click)="slider.next()" class="arrow arrow--right">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
      </svg>
    </div>
  }

</div>

<app-ui-icon (click)="closeDialog()" class="dialog-close-btn" color="var(--grey-1)" name="close"
             size="lg"></app-ui-icon>
